import { render, staticRenderFns } from "./UnprocessedPaymentDetails.vue?vue&type=template&id=0ffc342c&"
import script from "./UnprocessedPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./UnprocessedPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports